
      <i [ngClass]="iconClasses"
         [title]="iconTitle"
         aria-hidden="true"></i>
      <span
        class="hidden-for-sighted"
        [textContent]="iconTitle"
        *ngIf="iconTitle"></span>
    